import { Container } from '@/atoms';
import { CardBlog, Grid, Pagination } from '@/molecules';
import { Breadcrumbs } from '@/organisms';
import { FlexibleContent, HeroSlider } from '@/templates';

import { routes } from '@/lib/routes';

import type { FunctionComponent } from 'react';
import type { TypeBlogCategoryProps } from './types';

/**
 * BlogCategory
 */
export const BlogCategory: FunctionComponent<TypeBlogCategoryProps> = ({
  flexible,
  hero,
  breadcrumbs,
  posts,
  current,
  totalPages,
  slug,
  name,
}: TypeBlogCategoryProps) => (
  <>
    <HeroSlider hero={hero} />

    <Container wrapper padding="px-4 py-2.5 lg:px-4 xl:px-0 lg:pt-8 lg:pb-4">
      <Breadcrumbs breadcrumbs={breadcrumbs} mobileIndex={1} />
    </Container>

    <Container wrapper as="section" classNameWrapper="gap-10">
      {name && <h1>{name}</h1>}

      <Grid md={3} lg={4} className="gap-6 md:gap-y-8" outline={false}>
        {posts?.map((post, index) => (
          <Grid.Item key={index}>
            <CardBlog
              asTitle="h2"
              {...post}
              {...(post.excerpt && {
                excerpt: (
                  <div dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                ),
              })}
            />
          </Grid.Item>
        ))}
      </Grid>

      <Pagination
        createURL={(page) =>
          page
            ? routes.blog.category.page(slug, page + 1)
            : routes.blog.category.index(slug)
        }
        current={current - 1}
        totalPages={totalPages}
        className="mx-auto"
      />
    </Container>

    <FlexibleContent type="Category" flexible={flexible} />
  </>
);

BlogCategory.displayName = 'BlogCategory';
